var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"the-toaster"},_vm._l((_vm.toasts),function(toast){return _c('div',{key:toast.id,staticClass:"toast",on:{"click":function($event){return _vm.remove(toast)}}},[_c('div',{staticClass:"message",class:{
        info: _vm.isInfo(toast),
        success: _vm.isSuccess(toast),
        warning: _vm.isWarning(toast),
        error: _vm.isError(toast),
      }},[_vm._v(" "+_vm._s(toast.message)+" ")])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }